/* MC:REVIEW-WALL-20261023 — Review-Wand: wenige Hintergrund-Karten schweben frei (reines CSS, nur transform),
   vorne wechseln die großen Karten mit Glutrand. Läuft nur im Sichtbereich (IntersectionObserver), steht bei
   prefers-reduced-motion, Pause-Knopf (WCAG 2.2.2), Maus auf vorderer Karte hält den Wechsel an. */
(function () {
  'use strict';
  var wall = document.getElementById('mc-review-wall');
  if (!wall || wall.__mcRw) return;
  wall.__mcRw = true;

  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var reduced = function () { return !!(mq && mq.matches); };
  var visible = false, paused = false, timer = null;
  var btn = wall.querySelector('.mc-rw-pause');

  /* Vorne: je Platz eine Karte aktiv; Plätze reihum, damit nie alle gleichzeitig wechseln */
  var slots = Array.prototype.map.call(wall.querySelectorAll('.mc-rw-slot'), function (s) {
    return { el: s, cards: s.querySelectorAll('.mc-rw-card'), i: 0 };
  }).filter(function (s) { return s.cards.length > 1; });
  var turn = 0, hold = false, front = wall.querySelector('.mc-rw-front');
  if (front) {
    front.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hold = true; });
    front.addEventListener('pointerleave', function () { hold = false; });
  }
  function step() {
    if (!slots.length || hold) return;
    var vis = slots.filter(function (s) { return s.el.offsetParent !== null; });
    if (!vis.length) return;
    var s = vis[turn % vis.length];
    turn++;
    var cur = s.cards[s.i], nxt = s.cards[(s.i + 1) % s.cards.length];
    cur.classList.remove('is-on'); cur.classList.add('is-off'); cur.setAttribute('aria-hidden', 'true');
    nxt.classList.remove('is-off'); nxt.classList.add('is-on'); nxt.removeAttribute('aria-hidden');
    s.i = (s.i + 1) % s.cards.length;
    setTimeout(function () { cur.classList.remove('is-off'); }, 950);
  }

  function update() {
    var run = visible && !paused && !reduced() && !document.hidden;
    wall.classList.toggle('is-running', visible && !reduced());
    if (run && !timer) {
      timer = setInterval(step, window.innerWidth < 750 ? 4500 : 3400);
    } else if (!run && timer) {
      clearInterval(timer); timer = null;
    }
  }

  if (btn) {
    btn.addEventListener('click', function () {
      paused = !paused;
      wall.classList.toggle('is-paused', paused);
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.setAttribute('aria-label', btn.getAttribute(paused ? 'data-label-play' : 'data-label-pause'));
      update();
    });
  }
  document.addEventListener('visibilitychange', update);
  if (mq) {
    if (mq.addEventListener) mq.addEventListener('change', update); else if (mq.addListener) mq.addListener(update);
  }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      update();
    }, { rootMargin: '120px 0px' }).observe(wall);
  } else {
    visible = true; update();
  }
})();

/* MC:EIN-BEWERTUNGSBEREICH-20261028 (Projekt I104, Jonas 28.10.): eigene Bewertungsliste in der Review-Wand, kein Judge.me-Skript.
   Produktseite: „Read all reviews“ klappt die Liste auf; Seite 1 aus dem Judge.me-Metafeld (<template> im Snippet
   mc-reviews-section), weitere Seiten aus der öffentlichen Judge.me-Liste (JSON mit HTML).
   Bewertungsseite (data-alle): Liste gleich offen, Reiter je Produkt + „Mit Foto/Video“, „Alle“ mischt die Produkte nach Datum.
   Alles wird als Text übernommen (kein fremdes HTML in die Seite), Bilder/Videos nur von Judge.me. */
(function () {
  'use strict';
  var wall = document.getElementById('mc-review-wall');
  var more = wall && wall.querySelector('.mc-rw-more');
  if (!wall || !more || wall.__mcRwListe) return;
  var L = more.dataset, de = L.lang === 'de';
  var alleModus = !!L.alle;
  var quelleEl = document.querySelector('[data-mc-rv-quelle]');
  var cta = wall.querySelector('a.mc-rw-cta');
  if (!alleModus && (!quelleEl || !cta)) return;
  wall.__mcRwListe = true;
  var liste = more.querySelector('.mc-rw-list'), nextBtn = more.querySelector('.mc-rw-more__next');
  var fehlerEl = more.querySelector('.mc-rw-more__fehler');
  var PRO_KLICK = alleModus ? 8 : 6, PER_PAGE = alleModus ? 6 : 10; /* Bewertungsseite: kleinere Häppchen je Produkt, weniger Arbeit beim ersten Laden */
  var SHOP = (quelleEl && quelleEl.dataset.shopDomain) || L.shop || '';

  /* ---------- Judge.me-HTML lesen ---------- */
  function txt(el) {
    if (!el) return '';
    var ps = el.querySelectorAll('p');
    if (ps.length) return Array.prototype.map.call(ps, function (p) { return p.textContent.trim(); }).filter(Boolean).join('\n\n');
    return el.textContent.trim();
  }
  function bildUrl(u, w) {
    if (!/^https:\/\/review-images\.judgeme\.com\//.test(u || '')) return '';
    return u.replace(/([?&])width=\d+/, '$1width=' + w);
  }
  function lesen(root) {
    return Array.prototype.map.call(root.querySelectorAll('.jdgm-rev[data-review-id]'), function (r) {
      var pics = Array.prototype.map.call(r.querySelectorAll('.jdgm-rev__pics img, .jdgm-rev__pic-img'), function (i) {
        return i.getAttribute('data-src') || i.getAttribute('src') || '';
      }).map(function (u) { return bildUrl(u, 320); }).filter(Boolean);
      var vids = Array.prototype.map.call(r.querySelectorAll('.jdgm-vid-player[data-external-id]'), function (v) {
        return v.getAttribute('data-external-id');
      }).filter(function (id) { return /^[0-9a-f-]{36}$/i.test(id || ''); });
      var loc = r.querySelector('.jdgm-rev__location');
      var t = r.querySelector('.jdgm-rev__timestamp');
      var sc = r.querySelector('.jdgm-rev__rating');
      var score = parseFloat(sc ? sc.getAttribute('data-score') : '') || 5;
      var rep = r.querySelector('.jdgm-rev__reply-content, .jdgm-rev__reply');
      return {
        id: r.getAttribute('data-review-id'),
        name: txt(r.querySelector('.jdgm-rev__author')) || (de ? 'Anonym' : 'Anonymous'),
        ver: r.getAttribute('data-verified-buyer') === 'true',
        score: score,
        datum: t ? (t.getAttribute('data-content') || t.getAttribute('datetime') || '') : '',
        ort: loc ? loc.textContent.replace(/\s+/g, ' ').trim().replace(/^\((.*)\)$/, '$1') : '',
        cc: loc ? (loc.getAttribute('data-country-code') || '') : '',
        titel: txt(r.querySelector('.jdgm-rev__title')),
        text: txt(r.querySelector('.jdgm-rev__body')),
        antwort: rep ? txt(rep) : '',
        pics: pics.filter(function (u, i) { return pics.indexOf(u) === i; }),
        vids: vids.filter(function (u, i) { return vids.indexOf(u) === i; })
      };
    });
  }
  function zeit(r) { var d = Date.parse(String(r.datum).replace(' UTC', 'Z').replace(' ', 'T')); return isNaN(d) ? 0 : d; }
  /* Ausruf-/Lach-Texte (haha, gedehnte Buchstaben, !!!) nicht nach oben, wie vorne in der Wand */
  function gewicht(r) {
    var albern = /(ha){3,}|([a-z])\2{4,}|!{3,}/i.test(r.titel + ' ' + r.text);
    return (r.vids.length ? 3 : 0) + (r.pics.length ? 2 : 0) + (r.text.length >= 140 ? 3 : r.text.length >= 80 ? 2 : 0) + (r.score >= 5 ? 1 : 0) - (albern ? 5 : 0);
  }

  /* MC:POSITIV-20261028 (Jonas 28.10.: „so dass es positiv rüberkommt“): unter 4 Sterne oder Mängel-Worte kommen
     ans Ende der jeweiligen Liste (nicht versteckt: alle Bewertungen bleiben erreichbar) */
  var MANGEL = /\b(broke|broken|break|crack|cracked|damag|defect|melt|fell off|fall(s|ing)? off|came off|come off|worn (out|down|off)|wore (out|off)|refund|disappoint|poor|bad quality|waste|kaputt|defekt|gebrochen|abgefallen|abgebrochen|enttäusch|schlecht|geschmolzen|reklamation|kapot|cass[eé]|helaas|duur|leider|teuer|expensive|pricey|runs? out|ran out|wears? (out )?(fast|quick)|nutzt sich|schnell (ab|weg)|snel op|dommage|cher)/i;
  function schwach(r) {
    if (r.score < 4 || MANGEL.test(r.titel + ' ' + r.text + ' ' + r.antwort)) return true;
    return (r.titel + ' ' + r.text).trim().length < 45 && !r.pics.length && !r.vids.length; /* ganz kurz ohne Foto: hinter die ausführlichen */
  }

  /* ---------- Quellen: je Produkt eine Judge.me-Liste ---------- */
  var quellen = [];
  if (alleModus) {
    try { quellen = JSON.parse(L.alle); } catch (e) { quellen = []; }
  } else {
    quellen = [{ id: quelleEl.dataset.productId, label: '', href: '' }];
  }
  quellen = quellen.filter(function (q) { return q && q.id; }).map(function (q, i) {
    return { id: String(q.id), key: q.key || ('q' + i), label: q.label || '', href: q.href || '', items: [], spaeter: [], gesehen: {}, seite: 0, fertig: false, gesamt: 0 };
  });
  if (!quellen.length) return;
  function aufnehmen(q, rs) {
    var n = 0;
    rs.forEach(function (r) { if (!r.id || q.gesehen[r.id]) return; q.gesehen[r.id] = 1; r.q = q; (schwach(r) ? q.spaeter : q.items).push(r); n++; });
    return n;
  }
  function abschliessen(q) {
    q.fertig = true;
    if (q.spaeter.length) { q.items = q.items.concat(q.spaeter); q.spaeter = []; }
  }
  function holen(q) {
    if (q.fertig) return Promise.resolve(0);
    if (q.laedt) return q.laedt;
    var u = 'https://api.judge.me/reviews/reviews_for_widget?url=' + encodeURIComponent(SHOP) + '&shop_domain=' + encodeURIComponent(SHOP) +
      '&platform=shopify&page=' + (q.seite + 1) + '&per_page=' + PER_PAGE + '&product_id=' + encodeURIComponent(q.id);
    q.laedt = fetch(u, { credentials: 'omit' }).then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
      .then(function (j) {
        q.seite++;
        if (j && j.total_count) q.gesamt = j.total_count;
        var box = document.createElement('template'); box.innerHTML = j && j.html ? j.html : '';
        /* je Seite die aussagekräftigen zuerst (Medien, ausführlich), sonst Reihenfolge von Judge.me (neueste) */
        var rs = lesen(box.content); rs.forEach(function (r, i) { r._i = i; });
        rs.sort(function (a, b) { return gewicht(b) - gewicht(a) || a._i - b._i; });
        var n = aufnehmen(q, rs);
        if (!n || (q.gesamt && q.items.length + q.spaeter.length >= q.gesamt)) abschliessen(q);
        return n;
      })
      .then(function (n) { q.laedt = null; return n; }, function (e) { q.laedt = null; throw e; });
    return q.laedt;
  }

  /* ---------- Reiter + Auswahl ---------- */
  var reiter = 'alle', zeiger = {}, gezeigt = 0, laeuft = false, ende = false, rr = 0;
  function aktiv() { return reiter === 'alle' || reiter === 'medien' ? quellen : quellen.filter(function (q) { return q.key === reiter; }); }
  function passt(r) { return reiter !== 'medien' || r.pics.length || r.vids.length; }
  /* nächste n Bewertungen: je Quelle ein Zeiger, „Alle“ nimmt reihum aus jedem Produkt (sonst nur Fuß, weil die am häufigsten sind) */
  function naechste(n, runden) {
    var qs = aktiv(), out = [];
    function kopf(q) {
      var i = zeiger[q.key] || 0;
      while (i < q.items.length && !passt(q.items[i])) i++;
      zeiger[q.key] = i;
      return q.items[i];
    }
    function schritt() {
      var fehlt = qs.filter(function (q) { return !kopf(q) && !q.fertig; });
      if (fehlt.length) {
        if (runden <= 0) return Promise.resolve(out);
        runden--;
        return Promise.all(fehlt.map(holen)).then(schritt);
      }
      /* stärkste Bewertung zuerst (Medien, ausführlich), bei Gleichstand reihum über die Produkte */
      var best = null, bi = -1;
      for (var k = 0; k < qs.length; k++) { var j = (rr + k) % qs.length, h = kopf(qs[j]); if (h && (!best || gewicht(h) > gewicht(best))) { best = h; bi = j; } }
      if (best) rr = (bi + 1) % qs.length;
      if (!best) { ende = true; return Promise.resolve(out); }
      zeiger[best.q.key]++;
      out.push(best);
      return out.length >= n ? Promise.resolve(out) : schritt();
    }
    return schritt();
  }
  function nochMehr() {
    if (ende) return false;
    return aktiv().some(function (q) {
      var i = zeiger[q.key] || 0;
      for (; i < q.items.length; i++) if (passt(q.items[i])) return true;
      return !q.fertig;
    });
  }

  /* ---------- Karten ---------- */
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function datumText(s) {
    var ms = zeit({ datum: s });
    if (!ms) return '';
    try { return new Date(ms).toLocaleDateString(de ? 'de-DE' : 'en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }); } catch (e) { return ''; }
  }
  function karte(r) {
    var a = el('article', 'mc-rw-rev'); a.setAttribute('role', 'listitem');
    var head = el('div', 'mc-rw-rev__head');
    var av = el('span', 'mc-rw-avatar', (r.name.trim()[0] || '?').toUpperCase()); av.setAttribute('aria-hidden', 'true');
    var who = el('div', 'mc-rw-rev__who');
    var l1 = el('div', 'mc-rw-rev__line'); l1.appendChild(el('span', 'mc-rw-rev__name', r.name));
    if (r.ver) { var b = el('span', 'mc-rw-rev__badge'); b.innerHTML = L.check || ''; b.appendChild(document.createTextNode(L.lVer)); l1.appendChild(b); }
    var l2 = el('div', 'mc-rw-rev__line');
    var st = el('span', 'mc-rw-stars'); st.style.setProperty('--r', r.score); st.setAttribute('role', 'img'); st.setAttribute('aria-label', r.score + ' ' + L.lStars); l2.appendChild(st);
    if (r.ort || r.cc) {
      var loc = el('span', 'mc-rw-rev__loc');
      if (/^[A-Z]{2}$/.test(r.cc)) { var f = el('img'); f.src = 'https://public-images.judge.me/judgeme/flags/' + r.cc + '.svg'; f.alt = r.cc; f.width = 16; f.height = 12; f.loading = 'lazy'; f.decoding = 'async'; loc.appendChild(f); }
      if (r.ort) loc.appendChild(document.createTextNode(r.ort));
      l2.appendChild(loc);
    }
    who.appendChild(l1); who.appendChild(l2);
    head.appendChild(av); head.appendChild(who);
    var dt = datumText(r.datum); if (dt) head.appendChild(el('time', 'mc-rw-rev__date', dt));
    a.appendChild(head);

    var main = el('div', 'mc-rw-rev__main'), tx = el('div', 'mc-rw-rev__txt');
    var tA = r.titel.toLowerCase().slice(0, 16), bA = r.text.toLowerCase().slice(0, 16);
    if (r.titel && tA !== bA) tx.appendChild(el('h3', 'mc-rw-rev__title', r.titel));
    if (r.text) tx.appendChild(el('p', 'mc-rw-rev__body', r.text));
    main.appendChild(tx);
    if (r.pics.length || r.vids.length) {
      var m = el('div', 'mc-rw-rev__media');
      r.vids.forEach(function (id) {
        var v = el('button', 'mc-rw-tile is-video'); v.type = 'button'; v.setAttribute('aria-label', L.lVideo + ' ' + r.name); v.dataset.vid = id;
        var vi = el('img'); vi.src = 'https://review-videos.judgeme.com/' + id + '/preview.webp'; vi.alt = ''; vi.loading = 'lazy'; vi.decoding = 'async'; vi.width = 96; vi.height = 96;
        vi.onerror = function () { vi.remove(); };
        v.appendChild(vi); m.appendChild(v);
      });
      r.pics.forEach(function (u) {
        var t = el('button', 'mc-rw-tile'); t.type = 'button'; t.setAttribute('aria-label', L.lPhoto + ' ' + r.name); t.dataset.big = bildUrl(u, 1200);
        var im = el('img'); im.src = u; im.alt = L.lPhoto + ' ' + r.name; im.loading = 'lazy'; im.decoding = 'async'; im.width = 96; im.height = 96;
        t.appendChild(im); m.appendChild(t);
      });
      main.appendChild(m);
    } else { main.classList.add('is-ohne'); }
    a.appendChild(main);
    if (r.antwort) { var rp = el('p', 'mc-rw-rev__reply'); rp.appendChild(el('strong', '', L.lReply)); rp.appendChild(document.createTextNode(r.antwort)); a.appendChild(rp); }
    if (alleModus && r.q && r.q.label) {
      var pr = el('a', 'mc-rw-rev__prod', r.q.label); pr.href = r.q.href || '#';
      pr.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>');
      a.appendChild(pr);
    }
    return a;
  }
  function mehrKnoepfe(neu) {
    neu.forEach(function (a) {
      var p = a.querySelector('.mc-rw-rev__body');
      if (!p || p.scrollHeight <= p.clientHeight + 2) return;
      var b = el('button', 'mc-rw-rev__mehr', L.lMore); b.type = 'button'; b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', function () {
        var lang = a.classList.toggle('is-lang');
        b.textContent = lang ? L.lLess : L.lMore; b.setAttribute('aria-expanded', lang ? 'true' : 'false');
      });
      p.insertAdjacentElement('afterend', b);
    });
  }
  function zeigen(n, fokus) {
    if (laeuft) return Promise.resolve();
    laeuft = true; nextBtn.setAttribute('aria-busy', 'true'); fehlerEl.hidden = true;
    var stand = reiter;
    return naechste(n, alleModus ? 6 : 3).then(function (rs) {
      if (stand !== reiter) return;
      var neu = rs.map(function (r, i) { var k = karte(r); k.style.animationDelay = (i * 40) + 'ms'; liste.appendChild(k); return k; });
      gezeigt += neu.length;
      mehrKnoepfe(neu);
      if (fokus && neu[0]) { neu[0].setAttribute('tabindex', '-1'); neu[0].focus({ preventScroll: true }); }
    }, function () { fehlerEl.hidden = false; })
      .then(function () { laeuft = false; nextBtn.removeAttribute('aria-busy'); nextBtn.hidden = !nochMehr(); });
  }
  nextBtn.addEventListener('click', function () { zeigen(PRO_KLICK, true); });

  /* ---------- Reiter (nur Bewertungsseite) ---------- */
  var tabs = more.querySelector('.mc-rw-tabs');
  if (alleModus && tabs) {
    var defs = [{ key: 'alle', label: L.lAlle }].concat(quellen.map(function (q) { return { key: q.key, label: q.label }; }), [{ key: 'medien', label: L.lMedien }]);
    defs.forEach(function (d) {
      var b = el('button', 'mc-rw-tab', d.label); b.type = 'button'; b.dataset.key = d.key; b.setAttribute('aria-pressed', d.key === 'alle' ? 'true' : 'false');
      tabs.appendChild(b);
    });
    tabs.addEventListener('click', function (e) {
      var b = e.target.closest('.mc-rw-tab');
      if (!b || b.dataset.key === reiter || laeuft) return;
      Array.prototype.forEach.call(tabs.children, function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      reiter = b.dataset.key; zeiger = {}; gezeigt = 0; ende = false; rr = 0;
      liste.textContent = '';
      zeigen(PRO_KLICK);
    });
  }

  /* ---------- Start ---------- */
  var gestartet = false;
  function start() {
    if (gestartet) return; gestartet = true;
    if (alleModus) { zeigen(PRO_KLICK); return; }
    var q = quellen[0], box = document.createElement('div');
    var tpl = quelleEl.querySelector('template.mc-rv-quelle__daten');
    if (tpl) box.appendChild(tpl.content.cloneNode(true));
    var w = box.querySelector('.jdgm-rev-widg');
    q.gesamt = w ? parseInt(w.getAttribute('data-number-of-reviews'), 10) || 0 : 0;
    var avg = w ? parseFloat(w.getAttribute('data-average-rating')) || 0 : 0;
    var pg = box.querySelector('.jdgm-paginate');
    PER_PAGE = pg ? parseInt(pg.getAttribute('data-per-page'), 10) || 10 : 10;
    var erste = lesen(box);
    q.seite = Math.max(0, Math.ceil(erste.length / PER_PAGE));
    erste.forEach(function (r, i) { r._i = i; });
    erste.sort(function (a, b) { return gewicht(b) - gewicht(a) || a._i - b._i; });
    aufnehmen(q, erste);
    if (q.gesamt && q.items.length + q.spaeter.length >= q.gesamt) abschliessen(q);
    more.querySelector('.mc-rw-more__prod').textContent = quelleEl.dataset.productTitle || '';
    var sum = more.querySelector('.mc-rw-more__sum');
    if (avg && q.gesamt) {
      var s = el('span', 'mc-rw-stars'); s.style.setProperty('--r', avg); s.setAttribute('aria-hidden', 'true'); sum.appendChild(s);
      sum.appendChild(document.createTextNode(avg.toFixed(2).replace('.', de ? ',' : '.') + ' · ' + q.gesamt + ' ' + L.lReviews));
    }
    zeigen(PRO_KLICK);
  }
  /* Hintergrund: dieselben fliegenden Karten noch einmal, klebend hinter der Liste */
  function hintergrund() {
    var bg = wall.querySelector('.mc-rw-bg'), bg2 = more.querySelector('.mc-rw-more__bg');
    if (bg && bg2 && !bg2.firstChild) bg2.innerHTML = bg.innerHTML;
  }

  var offen = false;
  function setzen(auf, fokus) {
    offen = auf;
    more.hidden = !auf;
    if (auf) { hintergrund(); start(); }
    if (cta) { cta.setAttribute('aria-expanded', auf ? 'true' : 'false'); cta.firstChild.nodeValue = auf ? L.lClose : L.lOpen; }
    if (auf && fokus) { more.setAttribute('tabindex', '-1'); more.focus({ preventScroll: true }); more.scrollIntoView({ block: 'start' }); }
  }

  if (alleModus) {
    /* Bewertungsseite: Liste steht offen, Daten erst kurz vor Sichtbarkeit holen */
    hintergrund();
    /* MC:BEWERTUNGSSEITE-20261028: Aurora-Shader der Seite (mc-reviews-page) hält an, solange Wand/Liste im Bild sind
       (Sperrtest 28.10.: Shader + Liste 2 bis 3 fps, ohne Shader 12 bis 22); das letzte Bild bleibt stehen */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { window.__mcAuroraPause = es[0].isIntersecting; }).observe(wall);
    }
    if ('IntersectionObserver' in window) {
      /* früh und in einer Ruhepause laden (nicht mitten im Scrollen, Messung 28.10.) */
      var los = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 200); })(start, { timeout: 1500 }); };
      var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); los(); } }, { rootMargin: '2000px 0px' });
      io.observe(more);
    } else { start(); }
  } else {
    /* CTA: aus dem Link (Seite „Alle Bewertungen“) wird ein Aufklapp-Knopf; ohne Skript bleibt der Link */
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'mc-rw-cta mc-rw-more-btn';
    btn.setAttribute('aria-controls', more.id); btn.setAttribute('aria-expanded', 'false');
    btn.appendChild(document.createTextNode(L.lOpen));
    var svg = cta.querySelector('svg'); if (svg) btn.appendChild(svg);
    cta.parentNode.replaceChild(btn, cta); cta = btn;
    cta.addEventListener('click', function () { setzen(!offen, !offen); });
    var zu = more.querySelector('.mc-rw-more__zu');
    if (zu) zu.addEventListener('click', function () {
      setzen(false); wall.scrollIntoView({ behavior: 'smooth', block: 'start' }); cta.focus({ preventScroll: true });
    });
    /* Alte Sprungziele (Sterne oben auf der Seite, #judgeme-Links) öffnen jetzt die Liste */
    var ziel = /^#(judgeme|shopify-product-reviews|[a-z]{2}-reviews|reviews)/i;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a || !ziel.test(a.getAttribute('href'))) return;
      e.preventDefault(); e.stopPropagation(); setzen(true, true);
    }, true);
    if (ziel.test(location.hash)) setzen(true, true);
  }

  /* ---------- Großansicht (Karten + Galerie) ---------- */
  var lb = document.createElement('dialog'); lb.className = 'mc-rw-lb'; lb.setAttribute('aria-label', L.lPhoto);
  lb.innerHTML = '<div class="mc-rw-lb__box"><button type="button" class="mc-rw-lb__zu" aria-label="' + (L.lCloseView || 'Close') + '">×</button></div>';
  var lbBox = lb.firstChild;
  /* Inhalt sofort leeren (Video stoppt), nicht erst im close-Ereignis, das in Hintergrund-Tabs spät kommt */
  function leeren() { Array.prototype.slice.call(lbBox.querySelectorAll('img, iframe')).forEach(function (x) { x.remove(); }); }
  function lbZu() { leeren(); if (lb.open) lb.close(); }
  lb.addEventListener('cancel', leeren);
  lb.addEventListener('close', leeren);
  lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('mc-rw-lb__zu')) lbZu(); });
  document.body.appendChild(lb);
  more.addEventListener('click', function (e) {
    var t = e.target.closest('.mc-rw-tile');
    if (!t || typeof lb.showModal !== 'function') return;
    var x;
    if (t.dataset.vid) {
      x = document.createElement('iframe');
      x.src = 'https://iframe.mediadelivery.net/embed/' + (L.bunny || '748386') + '/' + t.dataset.vid + '?autoplay=true&preload=true';
      x.allow = 'autoplay; fullscreen; picture-in-picture'; x.allowFullscreen = true; x.title = L.lVideo;
    } else {
      x = document.createElement('img'); x.src = t.dataset.big; x.alt = t.getAttribute('aria-label');
    }
    leeren(); lbBox.appendChild(x); lb.showModal();
  });
})();
